export default __webpack_public_path__ + "static/page-header-slogan-bb7040f8373f9917adee6c5a3d53a882.svg";